import pako from 'pako';

/**
 * Installation file exporter
 * Handles exporting to .installation format (gzipped XML)
 */
export class InstallationExporter {
  /**
   * Export XML to .installation file
   * @param {string} xml - XML string
   * @param {string} filename - Filename without extension
   */
  static exportToInstallationFile(xml, filename) {
    try {
      // Compress the XML using gzip
      const compressed = pako.gzip(xml);
      
      // Create blob from compressed data
      const blob = new Blob([compressed], { type: 'application/octet-stream' });
      
      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.installation`;
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up
      URL.revokeObjectURL(url);
      
      console.log('Installation file exported successfully');
    } catch (error) {
      console.error('Error exporting installation file:', error);
      throw error;
    }
  }

  /**
   * Export XML to uncompressed .xml file (for debugging)
   * @param {string} xml - XML string
   * @param {string} filename - Filename without extension
   */
  static exportToXMLFile(xml, filename) {
    try {
      const blob = new Blob([xml], { type: 'application/xml' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.xml`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      URL.revokeObjectURL(url);
      
      console.log('XML file exported successfully');
    } catch (error) {
      console.error('Error exporting XML file:', error);
      throw error;
    }
  }

  /**
   * Validate XML structure
   * @param {string} xml - XML string
   * @returns {boolean} True if valid
   */
  static validateXML(xml) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(xml, 'application/xml');
      
      // Check for parsing errors
      const parserError = doc.querySelector('parsererror');
      if (parserError) {
        console.error('XML parsing error:', parserError.textContent);
        return false;
      }
      
      // Check for Installation root element
      const installation = doc.querySelector('Installation');
      if (!installation) {
        console.error('Missing Installation root element');
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('XML validation error:', error);
      return false;
    }
  }
}
